import {LoggerFactoryOptions, LFService, LogGroupRule, LogLevel} from "typescript-logging";
 
const defaultLoggerRule = new LogGroupRule(new RegExp(".+"), LogLevel.Debug);


// Create options instance and specify 2 LogGroupRules:
// * One for any logger with a name starting with model, to log on debug
// * The second one for anything else to log on info
const options = new LoggerFactoryOptions()
.addLogGroupRule(new LogGroupRule(new RegExp("model.+"), LogLevel.Debug))
.addLogGroupRule(defaultLoggerRule);
 
// Create a named loggerfactory and pass in the options and export the factory.
// Named is since version 0.2.+ (it's recommended for future usage)
export const LoggerFactory = LFService.createNamedLoggerFactory("LoggerFactory", options);